import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoApple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 22a5.6 5.6 0 0 1-1.91-.31A3.1 3.1 0 0 0 12 21.5c-.492.008-.98.085-1.45.23A7 7 0 0 1 9 22c-2.89 0-5-5.16-5-8.5C4 10.5 5.31 7 9 7a5.4 5.4 0 0 1 2.28.69q.346.189.72.31l.63-.28A6.15 6.15 0 0 1 15.58 7a6.27 6.27 0 0 1 4.24 2.43 1 1 0 0 1-.026 1.177 1 1 0 0 1-.314.273l-.17.07c-.68.27-1.82.89-1.81 2a2 2 0 0 0 1.69 2h.14A1 1 0 0 1 20 16c0 2.52-2.9 6-5 6m-3-2.5a5.1 5.1 0 0 1 1.69.28c.42.152.864.226 1.31.22.66 0 2.43-1.77 2.89-3.31A3.91 3.91 0 0 1 15.5 13a3.86 3.86 0 0 1 1.83-3.27 4.6 4.6 0 0 0-1.9-.73 4.2 4.2 0 0 0-1.95.55A3.8 3.8 0 0 1 12 10a3.9 3.9 0 0 1-1.59-.51A4 4 0 0 0 9 9c-2.86 0-3 3.75-3 4.5 0 3 2 6.5 3 6.5q.51-.049 1-.2a7 7 0 0 1 2-.3M14 4.996c.957-.957 1.287-2.179.736-2.73-.55-.55-1.773-.22-2.73.736-.956.957-1.285 2.179-.735 2.73.55.55 1.773.22 2.73-.736"
    />
  </svg>
);
export default SvgLogoApple;
